<list-view *ngIf="listePuissances" [liste]="listePuissances"></list-view>
<floating-button [listeActions]="listeActions"></floating-button>